import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Image } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';

dayjs.extend(buddhistEra);
dayjs.locale('th');

const { Text } = Typography;

function MobileProductItem({ item, idx, appHostname }) {
  const host = appHostname || 'https://meya.co.th';
  const imageSrc = `${host}/api/product/file/productitem/${item.productitem_id}/${item.productitem_id}-1-${item.img1_key}.jpg`;

  return (
    <div key={idx} className='product-item-mobile'>
      <div style={{ display: 'flex', gap: '12px', marginBottom: '8px' }}>
        <Image
          width={40}
          height={40}
          src={imageSrc}
          fallback='https://via.placeholder.com/40'
          style={{ borderRadius: '4px', objectFit: 'cover' }}
        />
        <div style={{ flex: 1 }}>
          <span className='product-name'>{item.productitem_name}</span>
          <Text type='secondary' style={{ fontSize: '11px', display: 'block' }}>
            {item.productitem_inter}
          </Text>
        </div>
      </div>

      <div className='product-grid-header'>
        <span>หน่วย</span>
        <span>วันหมดอายุ</span>
        <span>จำนวน</span>
        <span>ยอดรวม</span>
      </div>
      {item.orderitem_pricelist?.map((pl, pidx) => (
        <div className='product-grid-row' key={pidx}>
          <span>{pl.unit}</span>
          <span>{dayjs(pl.expire).format('DD MMM BB')}</span>
          <span>x{pl.select}</span>
          <span style={{ fontWeight: 600 }}>฿{Number(pl.subtotal).toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
}

MobileProductItem.propTypes = {
  item: PropTypes.object.isRequired,
  idx: PropTypes.number,
  appHostname: PropTypes.string,
};

export default MobileProductItem;
